import { useCallback } from 'react';
import { ApiBeneficiary } from '../../openapi';
import {
  BusinessBeneficiaryListItemContent,
  CryptoBeneficiaryListItemContent,
  IndividualBeneficiaryListItemContent,
  ListItem,
  ListItemButton,
  ListItemProps,
  UnknownBeneficiaryListItemContent,
} from '@razz-team/ui-web';

export const BADGE_SIZE = 16;

export type BeneficiaryListItemContentProps = {
  beneficiary: ApiBeneficiary;
};

export function BeneficiaryListItemContent({ beneficiary }: BeneficiaryListItemContentProps) {
  switch (beneficiary.type) {
    case 'CRYPTO':
      return (
        <CryptoBeneficiaryListItemContent
          network={beneficiary.accountNumber.type}
          currency={beneficiary.currency}
          subtype={beneficiary.subtype}
          displayName={beneficiary.displayName}
          accountNumber={beneficiary.accountNumber.value}
          beneficiaryName={beneficiary.beneficiaryName}
        />
      );
    case 'INDIVIDUAL':
      return (
        <IndividualBeneficiaryListItemContent
          currency={beneficiary.currency}
          displayName={beneficiary.displayName}
          individualName={beneficiary.individualName}
          accountNumber={beneficiary.accountNumber.value}
        />
      );
    case 'BUSINESS':
      return (
        <BusinessBeneficiaryListItemContent
          currency={beneficiary.currency}
          displayName={beneficiary.displayName}
          businessName={beneficiary.businessName}
          accountNumber={beneficiary.accountNumber.value}
        />
      );
    default:
      return <UnknownBeneficiaryListItemContent />;
  }
}

export interface BeneficiaryListItemProps extends ListItemProps {
  beneficiary: ApiBeneficiary;
}

export function BeneficiaryListItem({ beneficiary, ...props }: BeneficiaryListItemProps) {
  return (
    <ListItem {...props}>
      <BeneficiaryListItemContent beneficiary={beneficiary} />
    </ListItem>
  );
}

export interface BeneficiaryListItemButtonProps {
  beneficiary: ApiBeneficiary;
  onClick: (beneficiary: ApiBeneficiary) => void;
}

export function BeneficiaryListButtonItem({
  beneficiary,
  onClick,
}: BeneficiaryListItemButtonProps) {
  const handleClick = useCallback(() => {
    onClick(beneficiary);
  }, [onClick, beneficiary]);

  return (
    <ListItem disablePadding>
      <ListItemButton onClick={handleClick}>
        <BeneficiaryListItemContent beneficiary={beneficiary} />
      </ListItemButton>
    </ListItem>
  );
}
